import { render, staticRenderFns } from "./ChooseAddressCoordinates.vue?vue&type=template&id=097c8617&scoped=true&"
import script from "./ChooseAddressCoordinates.vue?vue&type=script&lang=js&"
export * from "./ChooseAddressCoordinates.vue?vue&type=script&lang=js&"
import style0 from "./ChooseAddressCoordinates.vue?vue&type=style&index=0&id=097c8617&scoped=true&lang=less&"
import style1 from "./ChooseAddressCoordinates.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097c8617",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
